import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Stack, Tooltip, Typography } from "@mui/material";
import { ErrorOutline as ErrorOutlineIcon } from "@mui/icons-material";

export type EpisodeTitleHistoryEntry = {
  title: string;
  replacedAt?: string;
};

type EpisodeTitleWithHistoryProps = {
  title: string;
  titleHistory?: EpisodeTitleHistoryEntry[] | null;
};

export const EpisodeTitleWithHistory: React.FC<EpisodeTitleWithHistoryProps> = ({
  title,
  titleHistory,
}) => {
  const { t } = useTranslation("explorer");
  const previous = [...(titleHistory ?? [])]
    .filter((entry) => entry.title)
    .reverse();

  return (
    <Stack
      direction="row"
      spacing={0.5}
      alignItems="flex-start"
      sx={{ typography: "body1", fontWeight: 600 }}
    >
      <Typography
        variant="inherit"
        fontWeight="inherit"
        color="text.primary"
        sx={{ whiteSpace: "normal", overflowWrap: "break-word", minWidth: 0 }}
      >
        {title}
      </Typography>
      {previous.length > 0 ? (
        <Tooltip
          title={
            <Box>
              <Typography
                variant="caption"
                sx={{ fontWeight: 600, display: "block", mb: 0.5 }}
              >
                {t("previousTitles")}
              </Typography>
              <Box component="ul" sx={{ m: 0, pl: 2 }}>
                {previous.map((entry, index) => (
                  <Typography
                    key={`${entry.title}-${index}`}
                    component="li"
                    variant="caption"
                  >
                    {entry.title}
                  </Typography>
                ))}
              </Box>
            </Box>
          }
        >
          <Box
            component="span"
            aria-label={t("titleChanged")}
            onClick={(e) => e.stopPropagation()}
            sx={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              height: "1.2em",
              flexShrink: 0,
              color: "warning.main",
              cursor: "default",
            }}
          >
            <ErrorOutlineIcon sx={{ fontSize: "1em" }} />
          </Box>
        </Tooltip>
      ) : null}
    </Stack>
  );
};
